import { Box, Typography, Grid } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  CertificateData,
  EnrollmentData,
  LessonContentData,
  LessonData,
  ModuleData,
} from 'services/dataService';
import CourseRegistrationData from 'services/dataService/CourseRegistrationData';
import FavorityCourseData from 'services/dataService/FavorityCourseData';
import PublicCoursesViewsData from 'services/dataService/PublicCoursesViewsData';
import history from 'services/history';
import theme from 'theme';
import LoginFooter from 'views/Welcome/components/Footer';
import CertificateDetails from './components/Certificate';
import CourseHeader from './components/CourseHeader';
import CourseInformation from './components/CourseInformation';
import InformationFooter from './components/InformationFooter';

const ValidateCertificate = () => {
  const classes = useStyle();
  const { id: id_user } = useSelector((state) => state?.auth);
  const { id: id_company_course, id_enrollment } = useParams();
  const [courseData, setCourseData] = React.useState();
  const [customization, setCustomization] = React.useState();
  const [modules, setModules] = React.useState([]);
  const { t } = useTranslation(['toastify', 'message', 'button']);
  const { auth, company } = useSelector((state) => state);
  const [courseBuy, setCourseBuy] = React.useState(false);
  const [courseActive, setCourseActive] = React.useState(false);
  const [userDate, setUserDate] = React.useState()
  const [buttonClicked, setButtonClicked] = React.useState(false);


  const getCourseInfo = async () => {
    const domain = window.location.hostname;

    const response = await CourseRegistrationData.getCourseInfo(
      id_company_course,
      { id_user, domain }
    );
    setCourseData(response.data);
    getCourseLessons(response.data?.id_course);
  };

  const getCourseLessons = async (id_course) => {
    const modules = (await ModuleData.getModuleByIdCourse(id_course)).data
      ?.modules;

    for (const course_module of modules) {
      course_module.lessons = await Promise.all(
        course_module?.lessons?.map(async (lesson) => {
          const course_lesson = (await LessonData.getLessonById(lesson?.id))
            .data;
          const course_lesson_content = (
            await LessonContentData.getLessonContent(lesson?.id)
          ).data.contents?.filter(
            (content) => content?.id_lesson === lesson?.id
          );

          return {
            ...course_lesson,
            course: course_lesson?.course?.name,
            content: course_lesson_content,
          };
        })
      );
    }
    setModules(modules);
  };

  const checkEnrollment = async () => {
    try {
      const resp = await CertificateData.getPublicValidateUserData(id_company_course, id_enrollment);
      setUserDate(resp?.data)
    } catch (error) {
      setCourseBuy(true);
    }
  }

  const getCompanyFooter = async () => {
    try {
      const {
        data: companyCustomization,
      } = await PublicCoursesViewsData.getCompanyCustomization(
        company?.domain_company
      );
      setCustomization(companyCustomization);
    } catch (error) { }
  };

  React.useEffect(() => {
    getCourseInfo();
    getCompanyFooter();
    checkEnrollment();

    if (document.querySelector('#root')) {
      document.querySelector('#root > div:nth-child(2)').scrollTop = 0;
    }
  }, []);
  
  return (
    !userDate || userDate.length === 0 || userDate[0]?.finished_at === null ? (
        <div className={classes.root}>
          <Grid container justify="center" spacing={4}>
            <Grid item lg={6} xs={12}>
              <div className={classes.content}>
                <img
                  alt="Not found"
                  className={classes.image}
                  src="/images/undraw_page_not_found_su7k.svg"
                />
                <Typography variant="h1">{t('Certificado Inválido')}</Typography>
                <Typography variant="subtitle2">
                  {t('message:404.mistake')}
                </Typography>
                <Link className={classes.link} to="/dashboard">
                  {t('button:commons.btn_back')}
                </Link>
              </div>
            </Grid>
          </Grid>
        </div>
      ) : (
        <Box>
          <CourseHeader
            info={courseData?.information}
            icon={courseData?.cardUrl}
            financial={courseData?.financial}
            signable={courseData?.signable}
            courseBlocked={courseActive}
            userDate={userDate}
          />
          <Box>
            <CourseInformation
              modules={modules}
              details={courseData?.courseDetails}
            />
          </Box>
          <Box>
            <CertificateDetails />
          </Box>
          <Box>
            <InformationFooter />
          </Box>
          <Typography style={{ paddingTop: theme.spacing(6) }} />
          {!auth?.signed && (
            <LoginFooter footer={customization?.company_footer} />
          )}
        </Box>
      )
  );   
};

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    minHeight: 'calc(100vh - 64px)',
  },
  content: {
    position: 'relative',
    top: -50,
    textAlign: 'center',

    '& h1': {
      margin: 'auto',
      maxWidth: 680,
      marginBottom: 16,
    },
    '& h6': {
      marginBottom: 48,
    },
  },
  image: {
    marginTop: 32,
    marginBottom: 32,
    display: 'inline-block',
    width: '100%',
    maxWidth: 560,
  },
  link: {
    color: '#176AE6',
    fontSize: 20,
    border: '1px solid #176ae680',
    padding: '8px 24px',
    borderRadius: 4,
    fontWeight: 500,
    transition: '250ms',

    '&:hover': {
      border: '1px solid #176ae6',
      backgroundColor: '#176AE60a',
    },
  },
}));


export default ValidateCertificate;
